module.exports = __webpack_public_path__ + "static/img/UTSC校区.48642bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC校区.png
// module id = ASV/
// module chunks = 0